import { TimeInterval } from 'root-constants'

export function createProductId({
  periodName,
  periodQuantity,
  price,
}: {
  periodName: TimeInterval | null
  periodQuantity: number | null
  price: number
}): string {
  return `mood_balance_${periodQuantity}_${periodName}_${price}`
}
